import { map, mapAwards } from 'helpers/mapForSelect'

const GET_COUNTRIES = 'dofe-fo/common/GET_COUNTRIES'
const GET_COUNTRIES_SUCCESS = 'dofe-fo/common/GET_COUNTRIES_SUCCESS'
const GET_COUNTRIES_FAIL = 'dofe-fo/common/GET_COUNTRIES_FAIL'
const GET_PUBLIC_COUNTRIES = 'dofe-fo/common/GET_PUBLIC_COUNTRIES'
const GET_PUBLIC_COUNTRIES_SUCCESS = 'dofe-fo/common/GET_PUBLIC_COUNTRIES_SUCCESS'
const GET_PUBLIC_COUNTRIES_FAIL = 'dofe-fo/common/GET_PUBLIC_COUNTRIES_FAIL'
const CHECK_CAPTCHA = 'dofe-fo/common/CHECK_CAPTCHA'
const CHECK_CAPTCHA_SUCCESS = 'dofe-fo/common/CHECK_CAPTCHA_SUCCESS'
const CHECK_CAPTCHA_FAIL = 'dofe-fo/common/CHECK_CAPTCHA_FAIL'
const GET_REGIONS = 'dofe-fo/common/GET_REGIONS'
const GET_REGIONS_SUCCESS = 'dofe-fo/common/GET_REGIONS_SUCCESS'
const GET_REGIONS_FAIL = 'dofe-fo/common/GET_REGIONS_FAIL'
const GET_PUBLIC_REGIONS = 'dofe-fo/common/GET_PUBLIC_REGIONS'
const GET_PUBLIC_REGIONS_SUCCESS = 'dofe-fo/common/GET_PUBLIC_REGIONS_SUCCESS'
const GET_PUBLIC_REGIONS_FAIL = 'dofe-fo/common/GET_PUBLIC_REGIONS_FAIL'
const GET_AWARD_LEVELS = 'dofe-fo/common/GET_AWARD_LEVELS'
const GET_AWARD_LEVELS_SUCCESS = 'dofe-fo/common/GET_AWARD_LEVELS_SUCCESS'
const GET_AWARD_LEVELS_FAIL = 'dofe-fo/common/GET_AWARD_LEVELS_FAIL'
const UPLOAD_IMAGE = 'dofe-fo/common/UPLOAD_IMAGE'
const UPLOAD_IMAGE_SUCCESS = 'dofe-fo/common/UPLOAD_IMAGE_SUCCESS'
const UPLOAD_IMAGE_FAIL = 'dofe-fo/common/UPLOAD_IMAGE_FAIL'
const DOWNLOADING_IMAGE = 'dofe-fo/common/DOWNLOADING_IMAGE'
const CHECK_AUTH_CODE = 'dofe-bo/common/CHECK_AUTH_CODE'
const CHECK_AUTH_CODE_SUCCESS = 'dofe-bo/common/CHECK_AUTH_CODE_SUCCESS'
const CHECK_AUTH_CODE_FAIL = 'dofe-bo/common/CHECK_AUTH_CODE_FAIL'

const initialState = {
  countries: {
    loading: false,
    loaded: false,
    list: []
  },
  regions: {
    loading: false,
    loaded: false,
    list: []
  },
  awardLevels: {
    loading: false,
    loaded: false,
    list: []
  },
  image: {
    loading: false,
    loaded: false
  }
}

// Country should be hidden when it has both isPresentNao and isPresentIc false
const filterCountries = countries =>
  countries.filter(country => country.isPresentNao || country.isPresentIc)

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        ...state,
        countries: {
          ...state.countries,
          loading: true
        }
      }
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          list: map(
            action.rejectEmpty ? filterCountries(action.result) : action.result
          ),
          data: action.result,
          loading: false,
          loaded: true
        }
      }
    case GET_COUNTRIES_FAIL:
      return {
        ...state,
        countries: {
          error: action.error,
          loading: false
        }
      }
    case GET_PUBLIC_COUNTRIES:
      return {
        ...state,
        countries: {
          ...state.countries,
          loading: true
        }
      }
    case GET_PUBLIC_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          list: map(
            action.rejectEmpty ? filterCountries(action.result.list) : action.result.list
          ),
          data: action.result.list,
          loading: false,
          loaded: true
        }
      }
    case GET_PUBLIC_COUNTRIES_FAIL:
      return {
        ...state,
        countries: {
          error: action.error,
          loading: false
        }
      }
    case GET_REGIONS:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
          loaded: false
        }
      }
    case GET_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          list: map(action.result),
          loading: false,
          loaded: true
        }
      }
    case GET_REGIONS_FAIL:
      return {
        ...state,
        regions: {
          error: action.error,
          loading: false
        }
      }
    case GET_PUBLIC_REGIONS:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
          loaded: false
        }
      }
    case GET_PUBLIC_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          list: map(action.result.list),
          loading: false,
          loaded: true
        }
      }
    case GET_PUBLIC_REGIONS_FAIL:
      return {
        ...state,
        regions: {
          error: action.error,
          loading: false
        }
      }
    case GET_AWARD_LEVELS:
      return {
        ...state,
        awardLevels: {
          loading: false,
          loaded: false
        }
      }
    case GET_AWARD_LEVELS_SUCCESS:
      return {
        ...state,
        awardLevels: {
          list: mapAwards(action.result),
          loading: false,
          loaded: true
        }
      }
    case GET_AWARD_LEVELS_FAIL:
      return {
        ...state,
        awardLevels: {
          error: action.error,
          loading: false
        }
      }
    case DOWNLOADING_IMAGE:
      return {
        ...state,
        image: {
          loading: action.bool
        }
      }
    default:
      return state
  }
}

export function getCountries() {
  return {
    types: [GET_COUNTRIES, GET_COUNTRIES_SUCCESS, GET_COUNTRIES_FAIL],
    promise: client => client.get('api/countries?with=ORG_STRUCTURE_INFO')
  }
}

export function getPublicCountries({ rejectEmpty = false } = {}) {
  return {
    types: [GET_PUBLIC_COUNTRIES, GET_PUBLIC_COUNTRIES_SUCCESS, GET_PUBLIC_COUNTRIES_FAIL],
    promise: client =>
      client.post('apiv2/registration/country/list', {
        removeToken: true,
        data: {
          sort: [{
            "attributeName": "name",
            "direction": "ASC"
          }]
        }
      }),
    rejectEmpty
  }
}

export function checkCaptcha(response) {
  return {
    types: [CHECK_CAPTCHA, CHECK_CAPTCHA_SUCCESS, CHECK_CAPTCHA_FAIL],
    promise: client =>
      client.post('https://www.google.com/recaptcha/api/siteverify', {
        external: true,
        data: {
          response
        }
      })
  }
}

export function getRegions() {
  return {
    types: [GET_REGIONS, GET_REGIONS_SUCCESS, GET_REGIONS_FAIL],
    promise: client => client.get('api/regions')
  }
}

export function getPublicRegions() {
  return {
    types: [GET_PUBLIC_REGIONS, GET_PUBLIC_REGIONS_SUCCESS, GET_PUBLIC_REGIONS_FAIL],
    promise: client =>
      client.post('apiv2/registration/region/list', {
        removeToken: true
      })
  }
}

export function getAwardLevels() {
  return {
    types: [GET_AWARD_LEVELS, GET_AWARD_LEVELS_SUCCESS, GET_AWARD_LEVELS_FAIL],
    promise: client => client.get('api/award-levels')
  }
}

export function uploadImage(data) {
  return {
    types: [UPLOAD_IMAGE, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAIL],
    promise: client =>
      client.put('api/blob', {
        data,
        formData: true
      })
  }
}

export function loadingImage(bool) {
  return {
    type: DOWNLOADING_IMAGE,
    bool
  }
}

export function isValidAuthCode(authCode) {
  return {
    types: [CHECK_AUTH_CODE, CHECK_AUTH_CODE_SUCCESS, CHECK_AUTH_CODE_FAIL],
    promise: client =>
      client.get(
        `api/authorization-code/check-validity?authorizationCode=${authCode}`,
        {
          removeToken: true
        }
      )
  }
}
